
import { useMsal } from '@azure/msal-react';
import { useState, useEffect } from 'react';
import { getIdTokenClaims } from './MsalConfig';

// Using the GroupId here since there is no good way to get the Azure AD Group names.
const READ_ONLY_USERS_GROUP_ID = '924fca66-379c-4717-a558-af2e7ebc03fd';
const COURSE_AND_MODULE_ADMIN_GROUP_ID = 'ff3c1afe-ec52-4937-8908-52286b91c9b9';
const HEAD_OF_SUBJECT_GROUP_ID = 'c09d013b-0561-4813-aca9-f507fc22b5cc';
const STATIC_DATA_ADMIN_GROUP_ID = 'c038b691-c965-46ac-a6bb-00937de091d0';
const SUPER_ADMIN_GROUP_ID = '854c0e07-c4a3-4193-aafa-58a434833bb3';

function userBelongsToGroup(idTokenClaims, groupId) {
    return (
        idTokenClaims?.groups?.length &&
        idTokenClaims.groups.indexOf(groupId) > -1
    );
}

export const useAzureADGroups = () => {
    const [isReadOnlyUser, setIsReadOnlyUser] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isHeadOfSubject, setIsHeadOfSubject] = useState(false);
    const [isStaticDataAdmin, setIsStaticDataAdmin] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);

    const { instance: msalInstance } = useMsal();

    useEffect(() => {
        getIdTokenClaims(msalInstance).then((idTokenClaims) => {
            setIsSuperAdmin(
                userBelongsToGroup(idTokenClaims, SUPER_ADMIN_GROUP_ID)
            );
            setIsStaticDataAdmin(
                userBelongsToGroup(idTokenClaims, STATIC_DATA_ADMIN_GROUP_ID)
            );
            setIsAdmin(
                userBelongsToGroup(idTokenClaims, COURSE_AND_MODULE_ADMIN_GROUP_ID)
            );
            setIsHeadOfSubject(
                userBelongsToGroup(idTokenClaims, HEAD_OF_SUBJECT_GROUP_ID)
            );
            setIsReadOnlyUser(
                userBelongsToGroup(idTokenClaims, READ_ONLY_USERS_GROUP_ID)
            );
            setUserRoleLocalStorage(idTokenClaims);
        });
    }, [msalInstance]);

    const canEditCourseAndModule = isSuperAdmin || isStaticDataAdmin || isAdmin;
    const canEditStaticData = isSuperAdmin || isStaticDataAdmin;

    return { canEditCourseAndModule, canEditStaticData, isReadOnlyUser, isHeadOfSubject, isSuperAdmin, isStaticDataAdmin, isAdmin  };
};

function setUserRoleLocalStorage(idTokenClaims) {
    if(userBelongsToGroup(idTokenClaims, READ_ONLY_USERS_GROUP_ID)) {
        localStorage.setItem('role', "Read Only");
    }  
    if(userBelongsToGroup(idTokenClaims, HEAD_OF_SUBJECT_GROUP_ID)) {
        localStorage.setItem('role', "Head of Subject");
    }      
    if(userBelongsToGroup(idTokenClaims, COURSE_AND_MODULE_ADMIN_GROUP_ID)) {
        localStorage.setItem('role', "Course and Module Admin");
    }     
    if(userBelongsToGroup(idTokenClaims, STATIC_DATA_ADMIN_GROUP_ID)) {
        localStorage.setItem('role', "Static Data Admin");
    }   
    if(userBelongsToGroup(idTokenClaims, SUPER_ADMIN_GROUP_ID)) {
        localStorage.setItem('role', "Super Admin");
    }  
}

// export const useAzureADGroups = () => {
//     return { canEditCourseAndModule : true, canEditStaticData: true, isReadOnlyUser: true,  isHeadOfSubject: true };

// };
